import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { summerlinConfig } from "./data";

export default function SummerlinPage() {
  return <CityPageTemplate config={summerlinConfig} />;
}